import RequestInstance from '../request.instance';
import { IResponse } from '../request.interface';
import { ISignal, ISignalDailyToken } from './signal.response.interface';

class SignalApiService {
  private readonly requestInstance: RequestInstance;
  constructor() {
    this.requestInstance = new RequestInstance();
  }

  // 获取signal列表
  async getSignalListApi(): Promise<IResponse<ISignal[]>> {
    return await this.requestInstance.businessRequest({
      url: `/signal/list`,
      method: 'GET',
    });
  }

  // 获取signal-daily列表
  async getSignalDailyListApi(): Promise<IResponse<ISignalDailyToken[]>> {
    return await this.requestInstance.businessRequest({
      url: `/signal/daily-tokens`,
      method: 'GET',
    });
  }

  // signal搜索
  async getSignalSearchApi(params: { keyword: string }): Promise<IResponse<ISignal[]>> {
    return await this.requestInstance.businessRequest({
      url: `/signal/token-list`,
      method: 'GET',
      params,
    });
  }
}

export default new SignalApiService();
